import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { FullPageWrapper, SpinnerLoader } from 'shared/ui'
import { contactsDetailsGlobalStore } from 'widgets/ContactsDetails/store'
import { ContactDetailsContentOverlay } from 'widgets/ContactDetailsContentOverlay/ContactDetailsContentOverlay'
import { ContactsDetails } from 'widgets/ContactsDetails'
import { TaggedContactsTable } from 'pages/settings/pages/tags/ui/TaggedContactsTable/TaggedContactsTable'
import {
  TaggedContactsProvider,
  useTaggedContactsContext,
} from 'pages/settings/pages/tags/context/taggedContactsContext'
import { TaggedContactsPageHeader } from 'pages/settings/pages/tags/ui/TaggedContactsPage/TaggedContactsPageHeader'
import { TaggedContactsPageSearch } from 'pages/settings/pages/tags/ui/TaggedContactsPage/TaggedContactsPageSearch'
import styles from './styles.module.scss'

const TaggedContacts = observer(() => {
  const { isEmpty, initialLoading, contactsDetailsStore } = useTaggedContactsContext()

  useEffect(() => {
    contactsDetailsGlobalStore.handleSetVariant('contacts')
    contactsDetailsGlobalStore.handleChangeCollapse(true)
  }, [])

  if (initialLoading) return <SpinnerLoader ariaLabel={'TaggedContactsPage'} />

  return (
    <>
      <ContactDetailsContentOverlay />
      {contactsDetailsStore ? <ContactsDetails store={contactsDetailsStore} /> : null}
      <section className={styles.page}>
        <TaggedContactsPageHeader />
        <div className={styles.wrap}>
          {!isEmpty && <TaggedContactsPageSearch />}
          <TaggedContactsTable />
        </div>
      </section>
    </>
  )
})

export const TaggedContactsPage = observer(() => {
  return (
    <FullPageWrapper>
      <TaggedContactsProvider>
        <TaggedContacts />
      </TaggedContactsProvider>
    </FullPageWrapper>
  )
})
